import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info } from 'lucide-react';
import { cn } from '../lib/cn.js';
import { Button } from './button.js';
import { Popover } from './popover.js';
/**
 * Explanation folded behind an ⓘ next to a label.
 *
 * Deliberately a Popover and NOT a Tooltip: what goes in here is a paragraph
 * about how a number is counted, and a paragraph needs to stay open while it
 * is read, be selectable, and be reachable by tap and by keyboard. A tooltip
 * is hover-scoped and vanishes the moment the pointer moves off the icon.
 */
export function HelpHint({ label, children, className, contentClassName }) {
    return (_jsxs(Popover, { children: [_jsx(Popover.Trigger, { asChild: true, children: _jsx(Button, { type: "button", variant: "ghost", size: "icon", "aria-label": label, className: cn('h-5 w-5 shrink-0 rounded-full p-0 align-middle text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)]', className), children: _jsx(Info, { className: "h-3.5 w-3.5", "aria-hidden": "true" }) }) }), _jsx(Popover.Content, { className: cn('max-w-xs text-xs leading-relaxed font-normal text-[var(--color-text-secondary)]', contentClassName), children: children })] }));
}
//# sourceMappingURL=help-hint.js.map